import React, { PureComponent } from "react";
import cx from "classnames";
import "./select-field.scss";
import FieldContainer from "../components/FieldContainer";

export default class SelectField extends PureComponent {
  render() {
    const { name, options, value, onChange, required = false } = this.props;
    return (
      <FieldContainer {...this.props}>
        <select
          name={name}
          required={required}
          onChange={(e) => onChange(name, e.target.value)}
          value={value || ""}
          className={cx("af-select-field", { "is-active": value })}
        >
          <option value=""></option>
          {options.map((option, idx) => {
            const { value, label } = option;
            return (
              <option key={value} value={value}>
                {label}
              </option>
            );
          })}
        </select>
      </FieldContainer>
    );
  }
}
